<template>
  <v-text-field
    v-model.number="password"
    :rules="rules.required.concat(rules.numeric)"
    :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
    :label="label"
    :mask="passwordMask"
    prepend-icon="mdi-lock-open"
    counter="9"
    class="dover-input"
    @click:append="showPassword = !showPassword"
    @change="onPasswordChange()"/>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    label: {
      type: String,
      required: true,
      default: () => []
    },
    initialValue: {
      type: Number,
      required: false,
      default: 0
    },
    rangeRules: {
      type: Array,
      required: true,
      default: () => [ 0, 0 ]
    }
  },
  data: () => ({
    showPassword: false,
    passwordMask: '',
    password: '',
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      numeric: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 9999) ]
    }
  }),
  mounted () {
    this.password = this.initialValue

    let maxChar = this.rangeRules[1].toString().length
    this.passwordMask = '#'.repeat(maxChar)
    this.rules = { ...this.rules, ...{ numeric: [ v => Vue.prototype.Maglink.RulesRange(v, this.rangeRules[0], this.rangeRules[1]) ] } }
  },
  methods: {
    onPasswordChange () {
      this.$emit('onPasswordChange', this.password)
    }
  }
}
</script>
